import { useState, useEffect } from 'react';
import { useNavigation, Form } from 'react-router';
import { Button } from "@/components/ui/button";
import { ReloadIcon } from "@radix-ui/react-icons";

interface LoadingButtonProps {
    /** Form action/destination URL */
    action: string;
    /** Button content when not loading */
    children: React.ReactNode;
    /** Additional CSS classes */
    className?: string;
    /** Text shown during loading state */
    loadingText?: string;
}

const LoadingButton = ({
                           action,
                           children,
                           className = "",
                           loadingText = "Laden..."
                       } : LoadingButtonProps) => {
    const navigation = useNavigation();
    const [isNavigating, setIsNavigating] = useState(false);

    // Track navigation state
    useEffect(() => {
        if (navigation.state === "submitting" || navigation.state === "loading") {
            setIsNavigating(true);
        } else {
            setIsNavigating(false);
        }
    }, [navigation.state]);

    return (
        <Form method="get" action={action}>
            <Button
                type="submit"
                disabled={isNavigating}
                className={`relative ${className} ${isNavigating ? 'cursor-not-allowed' : ''}`}
            >
                {isNavigating ? (
                    <div className="flex items-center gap-2">
                        <ReloadIcon className="h-4 w-4 animate-spin" />
                        <span>{loadingText}</span>
                    </div>
                ) : (
                    children
                )}
            </Button>
        </Form>
    );
};

export default LoadingButton;
